<ng-container *ngIf="!loading">
    <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-panel header="{{ idDocument ? ('VIGENCIADEDATOS.LBL_EDITARDOCUMENTO' | translate) : ('VIGENCIADEDATOS.LBL_AGREGARDOCUMENTO' | translate)}}">
            <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
                <div class="grid form-group">
                    <div class="col-12 md:col-3 lg:col-3">
                        <div class="div-form">
                            <label for="codigo">*{{"VIGENCIADEDATOS.LBL_CODIGO" | translate}}</label>
                            <input
                                pInputText
                                class="form-control"
                                id="idcodigo"
                                name="nameCodigo"
                                formControlName="codigo"
                                (keypress)="soloAlfanumerico($event)"
                                (input)="convertirAMayusculas($event); limitarLongitud($event, 6)"
                            />
                            <div class="p-message p-messages-error p-corner-all"
                                *ngIf="submitted && f.codigo.invalid && !f.codigo.errors?.codigoDuplicado">
                                {{"VIGENCIADEDATOS.LBL_CODIGO" | translate}} {{"LBL_REQUERIDO" | translate}}
                            </div>
                            <div class="p-message p-messages-error p-corner-all"
                                *ngIf="f.codigo.errors?.codigoDuplicado && (f.codigo.touched || submitted)">
                                {{ "VIGENCIADEDATOS.MSG_CODIGODUPLICADO" | translate }}
                            </div>

                        </div>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">
                        <div class="div-form">
                            <label for="nombre">*{{"VIGENCIADEDATOS.LBL_NOMBRE" | translate}}</label>
                            <input
                                pInputText
                                class="form-control"
                                id="idnombre"
                                name="nameNombre"
                                formControlName="nombre"
                                (keypress)="soloAlfanumericoConEspacios($event)"
                                (input)="limitarLongitud($event, 70)"
                            />
                            <div class="p-message p-messages-error p-corner-all"
                                *ngIf="submitted && f.nombre.invalid">
                                {{"VIGENCIADEDATOS.LBL_NOMBRE" | translate}} {{"LBL_REQUERIDO" | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">
                        <div class="div-form">
                            <label for="idTipoVigencia">*{{"VIGENCIADEDATOS.LBL_TIPOVIGENCIA" | translate}}</label>
                            <p-dropdown
                                id="idTipoVigencia"
                                name="nameidTipoVigencia"
                                [options]="listTypeValidity"
                                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                                formControlName="idTipoVigencia"
                                [autoWidth]="false"
                                (onChange)="shouldHideDuration()"
                            ></p-dropdown>
                            <div class="p-message p-messages-error p-corner-all"
                                *ngIf="submitted && f.idTipoVigencia.invalid">
                                {{"VIGENCIADEDATOS.LBL_TIPOVIGENCIA" | translate}} {{"LBL_REQUERIDO" | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3" *ngIf="shouldHideDuration()">
                        <div class="div-form">
                            <label for="duracionVigencia">*{{"VIGENCIADEDATOS.LBL_VIGENCIA" | translate}}</label>
                            <input
                                pInputText
                                class="form-control"
                                id="idduracionVigencia"
                                name="nameduracionVigencia"
                                formControlName="duracionVigencia"
                                (keypress)="limitToThreeDigits($event)"
                            />
                            <div class="p-message p-messages-error p-corner-all"
                                *ngIf="submitted && f.duracionVigencia.invalid">
                                {{"VIGENCIADEDATOS.LBL_VIGENCIA" | translate}} {{"LBL_REQUERIDO" | translate}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid form-group">
                    <div class="col-12 md:col-12 lg:col-12">
                        <div class="div-form">
                            <label for="descripcion">*{{"VIGENCIADEDATOS.LBL_DESCRIPCION" | translate}}</label>
                            <textarea
                                pInputTextarea
                                class="form-control"
                                id="iddescripcion"
                                name="namedescripcion"
                                formControlName="descripcion"
                                (input)="limitarLongitud($event, 500)"
                                rows="4"
                                style="resize: none;"
                            ></textarea>
                            <div class="p-message p-messages-error p-corner-all"
                                *ngIf="submitted && f.descripcion.invalid">
                                {{"VIGENCIADEDATOS.LBL_DESCRIPCION" | translate}} {{"LBL_REQUERIDO" | translate}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid form-group">
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="check-container">
                            <p-checkbox
                                formControlName="indicadorTercero"
                                label="{{ 'VIGENCIADEDATOS.TERCERO' | translate}}"
                                [binary]="true"
                                id="indicadorTercero"
                                name="indicadorTercero"
                            ></p-checkbox>
                            <p-checkbox
                                formControlName="indicadorSolicitarCliente"
                                label="{{ 'VIGENCIADEDATOS.LBL_SOLICITARCLIENTE' | translate}}"
                                [binary]="true"
                                id="indicadorSolicitarCliente"
                                name="indicadorSolicitarCliente"
                                ></p-checkbox>
                            <p-checkbox
                                formControlName="indicadorHabilitado"
                                label="{{ 'VIGENCIADEDATOS.LBL_HABILITADO' | translate}}"
                                [binary]="true"
                                id="indicadorHabilitado"
                                name="indicadorHabilitado"
                            ></p-checkbox>
                        </div>
                    </div>
                </div>
                <div class="grid form-footer-buttons">
                    <div *ngIf="!guardando" class="form-group col-12">
                        <a (click)="cancelar()" class="cancelar center-buttons-cancel">{{'BTN_CANCELAR' | translate}}</a>
                        <button pButton 
                                [icon]="'fa ' + (idDocument ? 'fa-save' : 'fa-plus')" 
                                [label]="(idDocument ? 'BTN_GUARDAR' : 'BTN_AGREGAR') | translate"
                                type="submit"
                                class="ui-button-primary">
                        </button>
                    </div>
                    <div *ngIf="guardando" class="form-group col-12">
                        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
                        <span style="margin-top: 5px;">{{'LBL_GUARDANDO' | translate }}</span>
                    </div>
                </div>
            </form>
          </p-panel>
        </div>
    </div>
</ng-container>
<app-loading *ngIf="loading"></app-loading>
<p-dialog header="Confirmación" [(visible)]="displayDialog"
          responsive="true" modal="true">
	<p>{{ 'VIGENCIADEDATOS.MSG_CONFIRMAGUARDAR' | translate }}</p>
	<p-footer>
		<div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
			<button type="button" pButton icon="fa fa-close" (click)="displayDialog=false" label="{{ 'BTN_NO' | translate }}"></button>
			<button type="button" pButton icon="fa fa-check" (click)="goBack()" label="{{ 'BTN_SI' | translate }}"></button>
		</div>
	</p-footer>
</p-dialog>